import { Typography } from "@material-ui/core";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import React from "react";


export default function Notify(props) {

    const {conformdialog,setConformDialog } = props;

    return (
        <Dialog open={conformdialog.isOpen}>
            <DialogContent>
                <Typography variant="h6">
                    {conformdialog.Title}
                </Typography>
            </DialogContent>
            <DialogActions>
            <Button hidden onClick={()=>{setConformDialog({...conformdialog,isOpen:false})}}>hidden</Button>
            <Button size='small' variant="contained" onClick={conformdialog.onConfirm}>Yes</Button>
            <Button size='small' variant="contained" onClick={conformdialog.noConfirm}>No</Button>
            </DialogActions>
        </Dialog>
    );
}